import { useCallback, useState } from 'react';

export const DEFAULT_PEN = { width: 5, color: '#000000', opacity: 1, smoothing: false, straighten: false };

const DASH = { dashed: [18, 24, 18], dotted: [8, 2, 8], solid: null };

/** The free-drawing brush settings; `apply` stores them and pushes them onto the fabric brush. */
const usePenBrush = (canvasRef) => {
    const [options, setOptions] = useState(DEFAULT_PEN);

    const apply = useCallback((next) => {
        setOptions(next);
        const canvas = canvasRef.current;
        if (!canvas) return;
        Object.entries(next).forEach(([key, value]) => {
            if (key === 'lineStyle') canvas.freeDrawingBrush.strokeDashArray = DASH[value] ?? null;
            else canvas.freeDrawingBrush[key] = value;
        });
        canvas.contextContainer.globalAlpha = next.opacity;
        canvas.renderAll();
    }, [canvasRef]);

    return { options, apply };
};

export default usePenBrush;
